import { QueryKeyConfig } from './api-helper';

export const dashboardApiKeyStore = {
  getDashboardCount: (): QueryKeyConfig => ({
    queryKey: [`GET_DASHBOARD_COUNT`],
    route: `/Dashboard`,
  }),
  getMasterDashboardCount: (): QueryKeyConfig => ({
    queryKey: [`GET_MASTER_DASHBOARD_COUNT`],
    route: `/Dashboard/GetMasterDashboard`,
  }),
};
